import { moodTags } from "@/mocks/quotes";

const stats = [
  { value: "60+", label: "伤感与治愈文案" },
  { value: "6", label: "心情标签分类" },
  { value: "4", label: "深夜陪伴场景" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full bg-background-100 overflow-hidden pt-24 pb-16 md:pt-32 md:pb-24">
      <div className="absolute -top-24 -right-16 w-80 h-80 rounded-full bg-accent-100/60 blur-3xl" aria-hidden="true"></div>
      <div className="absolute bottom-0 -left-24 w-72 h-72 rounded-full bg-secondary-100/50 blur-3xl" aria-hidden="true"></div>

      <div className="relative w-full max-w-6xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="animate-float-up">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs tracking-wide">
            <i className="ri-sun-line"></i>
            温柔克制的文字，写给每一个深夜独处的你
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-semibold leading-snug text-foreground-950">
            长日光阴里的伤感文案
            <br />
            与治愈系心情语录
          </h1>

          <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-700 max-w-xl">
            这里整理了长日光阴风格的伤感文案、心情语录与治愈系短句，用温柔克制的文字表达时光感悟与内心独白。
            适合情绪低落或深夜独处时阅读，也能为你的朋友圈配文提供一点文艺灵感。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <a
              href="#quotes"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-book-open-line text-base"></i>
              开始阅读今日文案
            </a>
            <a
              href="#companion"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-800 hover:bg-background-50 transition-colors cursor-pointer text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-moon-line text-base"></i>
              我是深夜来的
            </a>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-8 gap-y-4">
            {stats.map((s) => (
              <div key={s.label}>
                <p className="font-heading text-2xl font-semibold text-primary-600">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-500 mr-1">热门心情：</span>
            {moodTags.slice(1, 5).map((tag) => (
              <a
                key={tag.key}
                href="#quotes"
                className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs hover:bg-secondary-200 transition-colors cursor-pointer"
              >
                {tag.label}
              </a>
            ))}
          </div>
        </div>

        <div className="relative animate-float-up">
          <div className="relative w-full h-[320px] sm:h-[420px] lg:h-[520px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20still%20life%20of%20an%20open%20book%20beside%20a%20steaming%20cup%20on%20a%20wooden%20windowsill%2C%20soft%20late%20afternoon%20light%20falling%20across%20dried%20flowers%2C%20muted%20beige%20and%20terracotta%20tones%2C%20quiet%20editorial%20mood%2C%20gentle%20shadows%2C%20calm%20nostalgic%20atmosphere%2C%20high%20detail&width=900&height=1200&seq=longday-hero-2026-a1&orientation=portrait"
              alt="暖色调的窗边静物，摊开的书与冒热气的杯子，搭配干花与午后光线"
              title="长日光阴 伤感文案 治愈系短句 封面图"
              className="w-full h-full object-top object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent" aria-hidden="true"></div>
          </div>

          <div className="absolute -bottom-6 left-4 right-4 md:left-6 md:right-auto md:w-72 rounded-xl bg-background-50 border border-background-200/70 p-5">
            <p className="flex items-center gap-2 text-xs text-accent-800 mb-2">
              <i className="ri-star-smile-line"></i>
              今日一句
            </p>
            <p className="font-heading text-sm leading-relaxed text-foreground-900">
              「日落尤其温柔，人间皆是浪漫。」
            </p>
            <p className="mt-2 text-xs text-foreground-500">适合傍晚在窗边发呆时看一眼。</p>
          </div>
        </div>
      </div>
    </section>
  );
}